export default class APIError extends Error {
  public error: string;
  public status: number;
  public details: any;

  constructor(
    error: string = "API error",
    details: string,
    status: number,
    context?: string
  ) {
    let message = error;
    if (context) {
      message = `${context}: ${message}`;
    }
    super(message);

    this.error = error;
    this.status = status;
    this.details = details;
  }
}



// WEBPACK FOOTER //
// ./src/api/APIError.ts